export const RemoveIcon = () => {
	return (
		<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.75021 0.74979L8.99979 8.99937M8.99979 0.74979L0.75021 8.99937"
				stroke="#ED0100"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
